import Vue from 'vue'
import './pollyfills'
import axios from 'axios'
import VueRouter from 'vue-router'
import JsonCSV from 'vue-json-csv'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import moment from 'moment'
import https from 'https'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar';

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'
// plugin setup

import vueEsign from 'vue-esign'


Vue.use(vueEsign)




Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.component('downloadCsv', JsonCSV);

Vue.use(VeeValidate)
locale.use(lang)

Vue.prototype.$apiUrl = 'https://e-contracts.eu/api' //'http://localhost:3000/api'
Vue.prototype.$GuestUrl = 'https://e-contracts.eu/guest' //'http://localhost:3000/api'
Vue.prototype.$http = axios

Vue.filter('formatDate', function(value) {
  if (value) {
    if(isNaN(new Date(value).getTime())) {
      value = value.toString().split('T')[0].split('-')
      return moment(new Date(value[2] + '-' + value[0]+ '-' + value[1])).format('DD/MM/YYYY')
    } else {
      return moment(String(value)).format('DD/MM/YYYY')
    }

  }
});
// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
});


router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requireAuth)) {
    if (!localStorage.token || !localStorage.exp || localStorage.exp <= new Date()) {

      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
        next()
    }
  } else {
    next()
  }
})


initProgress(router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})
